import * as S from '@unionfab/ufc-shop-commons';
import { i18nFormat } from '@unionfab/ufc-shop-commons';
import { Spin } from 'antd';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import { UnpaidShopOrderCard } from '../../components/info/UnpaidShopOrderCard';
import { TechCategorySelector } from '../../components/select/TechCategorySelector';
import { QuoteFilesUploader } from '../../components/uploader';
import styles from './index.module.less';

interface NewShopQuoteDesktopProps {
  className?: string;
  style?: Record<string, string | number>;
  spinning: boolean;
  isDemoUser: boolean;
  hasAuthenticated: boolean;
  unpaidOrders: any[] | undefined;
  isLoading: boolean;
  curTechCategory: any;
  onTechCategoryChange: (_: any, t: any) => void;
  onBatchUploadSuccess: (files: S.D3ModelFile[]) => Promise<void>;
}

export const NewShopQuoteDesktop = ({
  className,
  style,
  spinning,
  isDemoUser,
  hasAuthenticated,
  unpaidOrders,
  isLoading,
  curTechCategory,
  onTechCategoryChange,
  onBatchUploadSuccess,
}: NewShopQuoteDesktopProps) => {
  return (
    <div
      style={style}
      id="NewShopQuote"
      className={cn(className, styles.container)}
    >
      <Spin spinning={spinning}>
        <div
          className={cn(
            styles.content,
            (isDemoUser || !hasAuthenticated) && styles.unAuthContent,
          )}
        >
          <TechCategorySelector
            tech={curTechCategory}
            className={styles.tecSelector}
            onChange={onTechCategoryChange}
          />

          <div className={styles.filesUploaderWrapper}>
            <div className={styles.filesUploaderTitle}>
              <h3 className={styles.subTitle}>
                {i18nFormat('Upload design and configure parts to get a quote')}
              </h3>
              <Link target="_blank" to={`/pdfviewer?doc=design_spec`}>
                {i18nFormat('Design specification')} &gt;
              </Link>
            </div>
            <QuoteFilesUploader
              uploaderId={'quote-editor-d3model-uploader'}
              onBatchUploadSuccess={onBatchUploadSuccess}
            />
          </div>
        </div>

        {!isDemoUser && hasAuthenticated && (
          <div className={styles.recentOrdersWrapper}>
            <h3 className={styles.subTitle}>
              {i18nFormat('Pick Up Where You Left Off')}
            </h3>

            <Spin spinning={isLoading}>
              <div className={styles.orders}>
                {(unpaidOrders || []).map(o => (
                  <UnpaidShopOrderCard order={o} key={o.id} />
                ))}
              </div>
            </Spin>
          </div>
        )}
      </Spin>
    </div>
  );
};

NewShopQuoteDesktop.displayName = 'NewShopQuoteDesktop';
